module.exports = __webpack_public_path__ + "static/media/No Matter How Hard We Try (ft Ben Goldstein).5bd1beab.jpg";